import appInfo from '@/helper/appInfo'

export default {
    enabled: process.env.VUE_APP_DEV ?? false,

    init() {
        this
            .info('-----[ Spoiled - ' + appInfo.meta.version + ' ]-----')
            .warn('Debug: activated')
    },
    info(data) {
        if (this.enabled) console.info(data);

        return this
    },
    warn(data) {
        if (this.enabled) console.warn(data);

        return this
    },
    error(data) {
        if (this.enabled) console.error(data);

        return this
    }
}